var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityGrid } from '../entities/entity-grid';
import { SiteFooterLayout } from '../entities/site-footer-layout';
import { SearchBar } from '../elements/search-bar';
import { useSearch } from '../hooks/use-search';
import { NoResultsLayout } from '../elements/no-results-layout';
import { WaitMessage } from '../elements/wait-message';
import { SiteFooterProvider } from '../context/site-footer-context';
import { ContentNode } from '../entities/content-node';
var cls = classNames('radar-opportunities-layout');
export var ExplorerEntityGridLayoutDefaultProps = {
  view: 'explorer',
  showSearchBar: false,
  isDetached: false,
  isExplorer: true,
  spacing: 4
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n    ", "\n  "], ["\n    \n    ", "\n  "])), function (_a) {
    var isDetached = _a.isDetached;
    return isDetached && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-top: ", ";\n    "], ["\n      padding-top: ", ";\n    "])), theme.UNIT(3));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isDetached = _a.isDetached;
    return isDetached && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-top: ", ";\n    "], ["\n      padding-top: ", ";\n    "])), theme.UNIT(4));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    gap: ", ";\n    padding: 0 ", " ", ";\n\n    ", "\n  "], ["\n    gap: ", ";\n    padding: 0 ", " ", ";\n\n    ", "\n  "])), theme.UNIT(2), theme.UNIT(3), theme.UNIT(3), function (_a) {
    var isExplorer = _a.isExplorer;
    return !isExplorer && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding: 0 0 ", ";\n    "], ["\n      padding: 0 0 ", ";\n    "])), theme.UNIT(3));
  }),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    min-height: 85vh;\n    padding: 0 ", " ", ";\n\n    ", "\n  "], ["\n    min-height: 85vh;\n    padding: 0 ", " ", ";\n\n    ", "\n  "])), theme.UNIT(4), theme.UNIT(4), function (_a) {
    var isExplorer = _a.isExplorer;
    return !isExplorer && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding: 0 0 ", ";\n    "], ["\n      padding: 0 0 ", ";\n    "])), theme.UNIT(4));
  })
});
var SearchBarStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 100%;\n    flex: 1;\n  "], ["\n    width: 100%;\n    flex: 1;\n  "])))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    margin-bottom: ", ";\n  "])), theme.UNIT(3), theme.UNIT(3))
});
var ControlHeaderStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n  "], ["\n    display: flex;\n    flex-direction: row;\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var NoResultsLayoutStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FooterStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DescriptionContainerStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " ", " ", " ", ";\n    flex: 1;\n  "], ["\n    padding: ", " ", " ", " ", ";\n    flex: 1;\n  "])), theme.UNIT(0.5), theme.UNIT(2), theme.UNIT(0.5), theme.UNIT(1))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-right: 4px;\n    box-sizing: border-box;\n    color: ", ";\n    font-size: ", "em;\n    padding-bottom: ", ";\n  "], ["\n    margin-right: 4px;\n    box-sizing: border-box;\n    color: ", ";\n    font-size: ", "em;\n    padding-bottom: ", ";\n  "])), theme.COLOR('mid'), 14 / 16, theme.UNIT(3)),
  desktop: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding-bottom: 0;\n  "], ["\n    padding-bottom: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Controls: styled.div.attrs(cls.attr('controls'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  ControlHeader: styled.div.attrs(cls.attr('control-header'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ControlHeaderStyles),
  DescriptionContainer: styled.div.attrs(cls.attr('description-container'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), DescriptionContainerStyles),
  Description: styled(ContentNode)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  SearchBar: styled(SearchBar)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), SearchBarStyles),
  Grid: styled(EntityGrid)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  NoResultsLayout: styled(NoResultsLayout)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), NoResultsLayoutStyles),
  Footer: styled(SiteFooterLayout)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
export var ExplorerEntityGridLayout = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items,
    isDetached = props.isDetached,
    showSearchBar = props.showSearchBar,
    view = props.view,
    filters = props.filters,
    loading = props.loading,
    description = props.description,
    isExplorer = props.isExplorer,
    gridProps = __rest(props, ["className", "children", "items", "isDetached", "showSearchBar", "view", "filters", "loading", "description", "isExplorer"]);
  var _a = useSearch(items),
    searchTerm = _a.searchTerm,
    setSearchTerm = _a.setSearchTerm,
    filteredItems = _a.filteredItems;
  var onChange = function (name) {
    setSearchTerm(name);
  };
  var hasDescription = description && !!(description === null || description === void 0 ? void 0 : description.text);
  var Grid = props.gridComponent || My.Grid;
  return React.createElement(SiteFooterProvider, {
    value: {
      boundary: 'content'
    }
  }, React.createElement(My.Container, {
    isDetached: isDetached,
    className: className
  }, React.createElement(My.Body, {
    isExplorer: isExplorer
  }, (showSearchBar || filters) && React.createElement(My.Controls, null, React.createElement(My.ControlHeader, {
    hasDescription: hasDescription
  }, hasDescription && React.createElement(My.DescriptionContainer, null, React.createElement(My.Description, {
    entity: description
  })), showSearchBar && React.createElement(My.SearchBar, {
    variant: 'allBorders',
    searchTerm: searchTerm,
    onChange: onChange,
    placeholder: "Search Items"
  })), filters), filteredItems.length ? loading ? React.createElement(WaitMessage, null) : React.createElement(Grid, __assign({}, gridProps, {
    items: filteredItems
  })) : loading ? React.createElement(WaitMessage, null) : React.createElement(My.NoResultsLayout, null)), React.createElement(My.Footer, null)));
};
ExplorerEntityGridLayout.defaultProps = ExplorerEntityGridLayoutDefaultProps;
ExplorerEntityGridLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;